import React from "react";
import { useField } from "formik";
import {
  TextField,
  FormHelperText,
  FormControl,
} from "@mui/material";

interface TextInputProps {
  name: string;
  label?: string;
  required?: boolean;
  floatingLabel?: boolean;
  [key: string]: any; // for other TextField props
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  required,
  floatingLabel = false,
  ...props
}) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : "";

  if (floatingLabel) {
    return (
      <FormControl fullWidth error={!!errorText} sx={{ mb: 2 }}>
        <TextField
          {...field}
          {...props}
          variant="outlined"
          label={
            <>
              {label}
              {required && <span style={{ color: "red" }}>*</span>}
            </>
          }
          error={!!errorText}
          size="small"
          fullWidth
        />
        {errorText && <FormHelperText>{errorText}</FormHelperText>}
      </FormControl>
    );
  }

  return (
    <FormControl fullWidth error={!!errorText} sx={{ mb: 2 }}>
      {label && (
        <label>
          {label}
          {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <TextField
        {...field}
        {...props}
        variant="outlined"
        error={!!errorText}
        size="small"
        fullWidth
        slotProps={{
          inputLabel: floatingLabel ? {
            shrink: true,
          } : undefined
        }}
      />
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

export default TextInput;